import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/legal.css";

const CONSENT_KEY = "cla_cookie_consent";
const GPC_KEY = "cla_gpc_honored";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    // Honor Global Privacy Control automatically
    if (navigator.globalPrivacyControl === true) {
      localStorage.setItem(CONSENT_KEY, "essential");
      localStorage.setItem(GPC_KEY, "true");
      setVisible(false);
      return;
    }
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      setVisible(true);
    }
  }, []);

  const saveConsent = (value) => {
    localStorage.setItem(CONSENT_KEY, value);
    setVisible(false);
    setModalOpen(false);
  };

  const handleAcceptAll = () => saveConsent("all");
  const handleRejectNonEssential = () => saveConsent("essential");
  const handleSavePreferences = () => {
    const value = `custom:analytics=${analytics},marketing=${marketing}`;
    saveConsent(value);
  };

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const handleModalKeyDown = (e) => {
    if (e.key === "Escape") closeModal();
  };

  if (!visible && !modalOpen) return null;

  return (
    <>
      {visible && (
        <div
          className="cookie-banner"
          role="region"
          aria-label="Cookie consent"
        >
          <div className="cookie-banner-inner">
            <div className="cookie-banner-text">
              <p>
                We use essential cookies to operate this site. We do not use
                advertising or analytics cookies. By clicking "Accept All" you
                consent to any functional cookies. See our{" "}
                <Link to="/privacy">Privacy Policy</Link> for details.
              </p>
            </div>
            <div className="cookie-banner-actions">
              <button
                className="cookie-btn cookie-btn-accept"
                onClick={handleAcceptAll}
              >
                Accept All
              </button>
              <button
                className="cookie-btn cookie-btn-reject"
                onClick={handleRejectNonEssential}
              >
                Reject Non-Essential
              </button>
              <button
                className="cookie-btn cookie-btn-manage"
                onClick={openModal}
              >
                Manage Preferences
              </button>
            </div>
          </div>
        </div>
      )}

      {modalOpen && (
        <div
          className="cookie-modal-overlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby="cookie-modal-title"
          onKeyDown={handleModalKeyDown}
        >
          <div className="cookie-modal">
            <button
              className="cookie-modal-close"
              onClick={closeModal}
              aria-label="Close cookie preferences"
            >
              ×
            </button>
            <h2 id="cookie-modal-title">Cookie Preferences</h2>

            <div className="cookie-category">
              <div className="cookie-category-text">
                <strong>Essential Cookies</strong>
                <span>Required for the site to function. Cannot be disabled.</span>
              </div>
              <input
                type="checkbox"
                className="cookie-toggle"
                checked
                disabled
                aria-label="Essential cookies — always enabled"
                readOnly
              />
            </div>

            <div className="cookie-category">
              <div className="cookie-category-text">
                <strong>Analytics Cookies</strong>
                <span>Help us understand how visitors use the site. Not currently active.</span>
              </div>
              <input
                type="checkbox"
                className="cookie-toggle"
                checked={analytics}
                onChange={(e) => setAnalytics(e.target.checked)}
                aria-label="Analytics cookies"
              />
            </div>

            <div className="cookie-category">
              <div className="cookie-category-text">
                <strong>Marketing Cookies</strong>
                <span>Used for personalized advertising. Not currently active.</span>
              </div>
              <input
                type="checkbox"
                className="cookie-toggle"
                checked={marketing}
                onChange={(e) => setMarketing(e.target.checked)}
                aria-label="Marketing cookies"
              />
            </div>

            <button
              className="cookie-modal-save"
              onClick={handleSavePreferences}
            >
              Save Preferences
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieBanner;